module.exports = __webpack_public_path__ + "static/img/brees-homepage-hero.4f2aa49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-homepage-hero.jpg
// module id = NVIj
// module chunks = 1